import React from "react"
import { I18nextProvider } from "react-i18next"
import i18n from "./i18n"

export const wrapRootElement = ({ element }) => (
  <I18nextProvider i18n={i18n}>{element}</I18nextProvider>
)


// gatsby-browser.js
// export const onClientEntry = () => {
//     const langs = ["ur", "he", "pt", "ru", "bn", "ar", "fr", "es", "hi", "zh", "en"]
//     const detectedLang = navigator.language.split("-")[0];
//     const userLang = langs.includes(detectedLang) ? detectedLang : "en";
//     // Redirect to the user's language home page if on the root path
//     if (window.location.pathname === "/") {
//         window.location.replace(`/${userLang}/home`)
//     }
// }
